import { Component, OnInit } from '@angular/core';
import { BarcodeFormat } from '@zxing/library';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-modal-code-question',
  templateUrl: './modal-code-question.page.html',
  styleUrls: ['./modal-code-question.page.scss'],
})
export class ModalCodeQuestionPage implements OnInit {


  formatsEnabled: BarcodeFormat[] = [
    BarcodeFormat.EAN_13,
    BarcodeFormat.EAN_8,
    BarcodeFormat.QR_CODE,
    BarcodeFormat.UPC_A,
    BarcodeFormat.UPC_E,
    BarcodeFormat.UPC_EAN_EXTENSION
  ];
  
  hasPermission: boolean;

  qrResultString: string;

  constructor(
    public modalController: ModalController, 
    private analyticsService: AnalyticsService
  ) { 
    this.analyticsService.AnalyticsServiceModalView('code-question');
  }

  ngOnInit() {
  }

  clearResult(): void {
    this.qrResultString = null;
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  //Function to close modal
  closeModal() {
    this.modalController.dismiss();
  }

  saveResult(){
    this.modalController.dismiss(this.qrResultString);
  }
}
